import React, { useMemo } from 'react';
import { titlePaths } from '@warehouse/title/core';
import { TitleTextInputField } from '@warehouse/title/ui';

export function SortTitleField({ localizedInfoUuid }: { localizedInfoUuid: string }) {
	const path = useMemo(() => titlePaths.titleSort(localizedInfoUuid), [localizedInfoUuid]);

	return <TitleTextInputField label="Sort Title" path={path} />;
}
